import axiosInstance from '../config/axiosInstance';

export type PublicLeadSource =
    | 'pricing'
    | 'proa'
    | 'industrial';

export type PublicLeadInterest =
    | 'pricing'
    | 'industrial'
    | 'both'
    | 'undecided';

export interface PublicLeadPayload {
    name: string;
    email: string;
    company: string;
    tier?: string | null;
    message?: string;
    source?: PublicLeadSource;
    interest?: PublicLeadInterest | null;
}

export interface PublicLeadResponse {
    message: string;
}

export const submitPublicLead = async (
    payload: PublicLeadPayload
): Promise<PublicLeadResponse> => {
    const response = await axiosInstance.post<PublicLeadResponse>(
        '/leads/',
        payload
    );

    return response.data;
};